import React, { ReactNode, FC } from 'react';
import { Box, styled } from '@material-ui/core';
import { palette } from '../../../theme/palette';

interface Props {
  color?: string;
  style?: {
    [x: string]: ReactNode;
  };
  text: ReactNode;
}

const BoxIcon = styled(Box)({
  width: 24,
  height: 24,
  backgroundColor: '#fff',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: 14,
  fontWeight: 'bold',
  borderRadius: 50,
});

const TextIcon: FC<Props> = ({ color = palette.primary.main, style, text }) => {
  return (
    <BoxIcon
      style={{
        color,
        ...style,
      }}
    >
      {text}
    </BoxIcon>
  );
};

export default TextIcon;
